import { render, staticRenderFns } from "./wait_delivery_detail_redirect.vue?vue&type=template&id=8d2c5a4a"
import script from "./wait_delivery_detail_redirect.vue?vue&type=script&lang=js"
export * from "./wait_delivery_detail_redirect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports